// Product Card Swiper
class ProductCardSwiperClean {
  constructor() {
    this.initialized = new Set();
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      setTimeout(() => this.init(), 500);
      return;
    }
    this.initializeSwipers();
  }

  initializeSwipers() {
    const productCards = document.querySelectorAll(".product-card-swiper");

    productCards.forEach((swiperContainer, index) => {
      if (this.initialized.has(swiperContainer) || swiperContainer.classList.contains('swiper-initialized')) {
        return;
      }

      try {
        const swiper = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,

          navigation: {
            nextEl: swiperContainer.querySelector(".swiper-button-next"),
            prevEl: swiperContainer.querySelector(".swiper-button-prev"),
          },

          pagination: {
            el: swiperContainer.querySelector(".swiper-pagination"),
            type: 'progressbar',
          },

          mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 2,
            releaseOnEdges: true,
            thresholdDelta: 20,
            thresholdTime: 200,
          },

          on: {
            init: function() {
              swiperContainer.setAttribute('data-swiper-initialized', 'true');
            }
          }
        });

        this.initialized.add(swiperContainer);
        this.addEventListeners(swiperContainer, swiper);

      } catch (error) {
        console.error(`Error creating swiper ${index + 1}:`, error);
      }
    });
  }

  addEventListeners(container, swiper) {
    const cardWrapper = container.closest('.card-wrapper');
    if (cardWrapper) {
      cardWrapper.classList.add('has-swiper-carousel');
      
      const problematicLinks = cardWrapper.querySelectorAll('a.full-unstyled-link');
      problematicLinks.forEach(link => {
        link.style.position = 'relative';
        link.style.zIndex = '1';
      });
      
      const cardContent = cardWrapper.querySelector('.card__content');
      const customCardContent = cardWrapper.querySelector('.card__content.custom_card_content');
      
      if (cardContent) {
        cardContent.style.position = 'relative';
        cardContent.style.zIndex = '1';
      }
      
      if (customCardContent) {
        customCardContent.style.position = 'relative';
        customCardContent.style.zIndex = '1';
      }
      
      const style = document.createElement('style');
      style.textContent = `
        .has-swiper-carousel .card__content::after,
        .has-swiper-carousel .card__content::before,
        .has-swiper-carousel .card__content.custom_card_content::after,
        .has-swiper-carousel .card__content.custom_card_content::before {
          display: none !important;
          content: none !important;
          pointer-events: none !important;
          position: absolute !important;
          top: -9999px !important;
          left: -9999px !important;
          z-index: -9999 !important;
          width: 0 !important;
          height: 0 !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    container.addEventListener('click', (e) => {
      const isNavigationButton = e.target.closest('.swiper-button-next') || 
                                 e.target.closest('.swiper-button-prev') || 
                                 e.target.closest('.swiper-pagination');
      
      if (!isNavigationButton) {
        e.preventDefault();
        e.stopPropagation();
        
        const productLink = cardWrapper.querySelector('a.full-unstyled-link[href*="/products/"]');
        if (productLink && productLink.href) {
          window.location.href = productLink.href;
        }
      }
    }, true);
  }
}

function initCleanSwipers() {
  new ProductCardSwiperClean();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCleanSwipers);
} else {
  initCleanSwipers();
}

window.addEventListener('shopify:section:load', () => {
  setTimeout(initCleanSwipers, 100);
});